import { type ForwardRefRenderFunction, forwardRef, type MouseEvent, useState } from 'react'

import { Visibility, VisibilityOff } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'

import { DSInputType, Input, type InputProps } from '../Input'
import { IconButtonStyled } from './styles'
export interface PasswordProps extends InputProps {
  placeholder: string
  maxLength?: number
  errorOutline?: boolean
}

const PasswordComponent: ForwardRefRenderFunction<HTMLInputElement, PasswordProps> = (
  {
    name,
    value,
    label,
    placeholder,
    height = 41,
    maxLength = 100,
    onChange,
    error = null,
    errorOutline = false,
  },
  ref,
) => {
  const [show, setShow] = useState(false)

  const handleClickShowPassword = () => {
    setShow((prevState) => !prevState)
  }

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <Input
      addorment
      design={DSInputType.MASTER_INPUT}
      error={error}
      errorOutline={errorOutline}
      height={height}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButtonStyled
              aria-label="toggle password visibility"
              data-testid="icon-password"
              edge="end"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {show ? (
                <Visibility color="primary" data-testid="visibility-on" />
              ) : (
                <VisibilityOff color="primary" data-testid="visibility-off" />
              )}
            </IconButtonStyled>
          </InputAdornment>
        ),
        inputProps: {
          maxLength,
        },
        placeholder,
      }}
      label={label}
      name={name}
      onChange={onChange}
      ref={ref}
      type={show ? 'text' : 'password'}
      value={value}
    />
  )
}

export const Password = forwardRef(PasswordComponent)
